import React from 'react';
import { ChevronsUpDown, Trash } from 'lucide-react';

export const PreferenceField = ({
  label,
  value,
  displayValue,
  placeholder,
  onSelect,
  onClear,
  isSpanish,
}) => {
  return (
    <div className='flex gap-4 items-center text-sm'>
      <span className="font-medium flex min-w-[12rem] text-left flex-1 ">
        {label}
      </span>
      <button
        className="w-full flex gap-2 justify-between items-center border-container rounded-full px-5 py-3 hover:bg-gray-50"
        onClick={onSelect}
      >
        {value ? (
          <p className="truncate max-w-[200px]">{displayValue || value}</p>
        ) : (
          <p className="opacity-75 truncate">{placeholder}</p>
        )}
        <ChevronsUpDown className="w-4 h-4 flex-shrink-0" />
      </button>
      {value && onClear && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
          className="text-sm"
          title={isSpanish ? 'Eliminar preferencia' : 'Clear preference'}
        >
          <Trash className="w-4 h-4 stroke-red-600 hover:stroke-red-800" />
        </button>
      )}
    </div>
  );
};
